<template>
    <v-card flat>
        <v-card-title>
            Listado
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
        </v-card-title>

        <v-data-table :headers="list_header" :items="aditivos" :search="search" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" item-key="cod_aditivo">

            <template v-slot:item.cod_aditivo="{ item }">
                <router-link :to="'/aditivos/' + item.cod_aditivo">{{
                    item.cod_aditivo
                }}</router-link>
            </template>

            <template v-slot:item.green_strength="{ item }">
                <v-simple-checkbox v-model="item.green_strength" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.fda="{ item }">
                <v-simple-checkbox v-model="item.fda" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.esponja="{ item }">
                <v-simple-checkbox v-model="item.esponja" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.fuego="{ item }">
                <v-simple-checkbox v-model="item.fuego" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.grasa="{ item }">
                <v-simple-checkbox v-model="item.grasa" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.desmoldeo="{ item }">
                <v-simple-checkbox v-model="item.desmoldeo" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.cables="{ item }">
                <v-simple-checkbox v-model="item.cables" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.aceite="{ item }">
                <v-simple-checkbox v-model="item.aceite" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.prioritario="{ item }">
                <v-simple-checkbox v-model="item.prioritario" disabled></v-simple-checkbox>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editAditivo(item.cod_aditivo)">mdi-pencil</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDelete" persistent max-width="400">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.cod_aditivo }}
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar la aditivo?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteAditivo(itemToDelete.cod_aditivo)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import AditivosDataService from "@/services/AditivosDataService";

export default {
    name: "AditivosList",
    data: () => ({
        aditivos: [],
        search: '',
        sortBy: 'cod_aditivo',
        sortDesc: false,
        list_header: [
            { text: 'Codigo', value: 'cod_aditivo' },
            { text: 'Descripcion', value: 'descripcion' },
            { text: 'Color', value: 'color' },
            { text: 'T.Servicio', value: 'temp_servicio' },
            { text: 'Densidad', value: 'densidad' },
            { text: 'Decimales', value: 'decimales' },
            { text: 'FDA', value: 'fda' },
            { text: 'Green', value: 'green_strength' },
            { text: 'Esponja', value: 'esponja' },
            { text: 'Aceite', value: 'aceite' },
            { text: 'Cables', value: 'cables' },
            { text: 'Desmoldeo', value: 'desmoldeo' },
            { text: 'Fuego', value: 'fuego' },
            { text: 'Grasa', value: 'grasa' },
            { text: 'Prioritario', value: 'prioritario' },
            { text: "Actions", value: "actions", sortable: false },
        ],
        dialogDelete: false,
        itemToDelete: {},
    }),
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        retrieveAditivos() {
            AditivosDataService.getAll()
                .then((response) => {
                    // console.log("ADITIVOS"); console.log(response.data);
                    this.aditivos = response.data.map(this.getDisplayAditivo);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        editAditivo(id) {
            this.$router.push({ name: "AditivoId", params: { id: id } });
        },
        deleteAditivo(id) {
            AditivosDataService.delete(id)
                .then(() => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.retrieveAditivos();
                    this.dialogDelete = false
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        getDisplayAditivo(aditivo) {
            return {
                cod_aditivo: aditivo.cod_aditivo,
                descripcion: aditivo.descripcion,
                decimales: aditivo.decimales,
                fda: aditivo.fda,
                prioritario: aditivo.prioritario,
                esponja: aditivo.esponja,
                temp_servicio: aditivo.temp_servicio,
                densidad: aditivo.densidad,
                aceite: aditivo.aceite,
                grasa: aditivo.grasa,
                green_strength: aditivo.green_strength,
                fuego: aditivo.fuego,
                desmoldeo: aditivo.desmoldeo,
                cables: aditivo.cables,
                color: aditivo.id_color ? aditivo.id_color.nombre + " (" + aditivo.id_color.ral + ") " + aditivo.id_color.referencia : "",
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
    },
    mounted() {
        this.retrieveAditivos();
    }
};
</script>